import { useId } from "react";
import { Link } from "react-router-dom";
import "./nav_button.css";

const sanitizeId = (value) => value.replace(/[^a-zA-Z0-9_-]/g, "-");

const NavButton = ({
  to,
  label,
  iconClass = "ion-log-in",
  className = "",
  inputId,
}) => {
  const generatedId = useId();
  const rawId = inputId || `nav-button-${generatedId}`;
  const safeId = sanitizeId(rawId);
  const containerClass = className ? `nav-button ${className}` : "nav-button";

  return (
    <div className={containerClass}>
      <input type="checkbox" id={safeId} />
      <label htmlFor={safeId}>
        <Link to={to}>
          <div className="button_inner q">
            <i className={`l ${iconClass}`}></i>
            <span className="t">{label}</span>
            <span>
              <i className="tick ion-checkmark-round"></i>
            </span>
          </div>
        </Link>
      </label>
    </div>
  );
};

export default NavButton;
